import App from "../containers/App.js";

const indexRoutes = [{ path: "/", component: App }];

export default indexRoutes;
